// extracted by mini-css-extract-plugin
export default {"editCommentForm":"EditCommentForm_editCommentForm__huZJA","editCommentFormActions":"EditCommentForm_editCommentFormActions__WyowS"};